import { defineComponent as _defineComponent } from 'vue'
import { buryPoint } from '@/apis/common/buryPoint'
import { getLabelInfo } from '@/apis/tag'
import { checkUserPermissions } from '@/auth/user_function'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { translateLang } from '@/data/i18n/translateLang'
import { PreferenceUpdateFnParam } from '@/plugins/preference'
import store from '@/store'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { deepCopy } from '@/util/LayoutFuncs'
import { Browser, translate } from '@/util/commonFun'
import {
  buryPointApi,
  genFinalRecord,
  verifyInputNumber,
} from '@/util/commonFuncs'
import { flatObj } from '@/util/commonFuncs'
import {
  Data,
  GenerateFileDB,
  addFileDBData,
  deleteFileDBData,
  getFileDBData,
} from '@/util/db/generateExportDB'
import { folderIsExist } from '@/util/fileSystem'
import { storageLocalFolder } from '@/util/fileSystem/generateFile'
import { message } from 'ant-design-vue'
import { Message } from 'element-ui'
import { groupBy } from 'lodash-es'
import Vue, {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  ref,
} from 'vue'

import MPaibanPlan from './components/m-paiban-plan.vue'

interface formDataType {
  isFrameDoorTip: boolean
  is_use_folder_export: boolean
  exNextTip: boolean
  isSurpLabelSetValue: boolean
  surpLabelSetValue: number | string
  inner_shape_tool_match: boolean
  enableMixPaiban: false // 是否开启不同颜色小板小板混排
  isUsePlankReuseMatchingPlankName: boolean
  mixPaibanSettings: Array<{
    id: string
    matCode: string
    originTexture: string[]
    targetTexture: string
  }>
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'moreSettings',
  setup(__props) {

const { proxy } = getCurrentInstance()!

let isSaveSettings = ref(false) // 控制加载保存按钮，默认进入页面不可点击
let dataHasDifOpenTip = ref(true)
const surpTagThrouInp = ref()
let formData = ref<formDataType>({
  isFrameDoorTip: true,
  is_use_folder_export: false,
  exNextTip: true,
  isDesMaterialNoCutTip: true,
  isSurpLabelSetValue: false,
  surpLabelSetValue: '',
  inner_shape_tool_match: false,
  enableMixPaiban: false, // 是否开启不同颜色小板小板混排
  isUsePlankReuseMatchingPlankName: false,
  mixPaibanSettings: [],
  enableSubTagDataSource: false,
  subTagDataSource: [],
  isSurNotLayout: false,
  plankNames: [],
  uniqueBarCode: false,
  genSimpleLabelBarcode: false,
})
// 原始数据
let oriData = {}
let currentInputPlankName = ref('')
let currentInputIndex = ref<number | null>(null)
let addPlankTip = ref('')
// 存储每个输入框的临时值和原始值
const tempPlankNames = reactive<
  Record<number, { value: string; original: string }>
>({})

const localFolder = reactive({
  current: null as number | null,
  folders: [] as any,
  oriCurrent: null as number | null,
})

// 只对Edge浏览器生效，其他浏览器不可使用,浏览器策略问题
const isSupportFileSys = computed(() => Browser.isEdge())

// 网络环境是否安全
const isNetWorkSafe = computed(() => {
  return window.isSecureContext
})
// 是否可以选择并切换本地文件
const isSupportOpe = computed(() => {
  return isNetWorkSafe.value && isSupportFileSys.value
})
const webToQt = computed(() => {
  return (window as any).webToQt
})

const preference = computed(() => {
  return store.state.preferencesSetting?.setting
})

const isLoadPref = computed(() => {
  return store.state.preferencesSetting?.isLoading
})

// 副标签权限
const hasSubTagPermission = computed(() => {
  return checkUserPermissions([USER_PERMISSION_KEY.SECONDARY_LABEL]) === true
})

const subTagOptions = ref<any[]>([])
const subTagDataSourceTip = ref('')
function getSubTagOptions() {
  getLabelInfo().then((res) => {
    if (res.data.status) {
      const list = Array.isArray(res.data.data) ? res.data.data : []
      subTagOptions.value = list.map((item: any) => ({
        ...item,
        label:
          item.label || item.sample || item.text || item.name || item.value,
        value: item.value,
      }))
    }
  })
}

function handleAddSubTagDataSource() {
  formData.value.subTagDataSource.push('')
}

function handleDelSubTagDataSource(index: number) {
  formData.value.subTagDataSource.splice(index, 1)
}

function handleChangeSubTagDataSource(index: number, value: string) {
  const otherDataSource = formData.value.subTagDataSource.filter(
    (item: string, idx: number) => idx !== index
  )
  if (otherDataSource.includes(value)) {
    message.error(translateLang('不允许添加重复数据源'))
    formData.value.subTagDataSource[index] = ''
  }
}

onMounted(() => {
  proxy.$preference.init(updatePreference, proxy.$route.path)
  getLocalFolder()
  if (hasSubTagPermission.value) {
    getSubTagOptions()
  }
})

/** 板件条码唯一 / 简易条码互斥，与 NC 导出设置一致 */
function handleUniqueBarCodeChange(e: { target: { checked: boolean } }) {
  if (e.target.checked) {
    formData.value.genSimpleLabelBarcode = false
  }
}

function handleGenSimpleLabelBarcodeChange(e: {
  target: { checked: boolean }
}) {
  if (e.target.checked) {
    formData.value.uniqueBarCode = false
  }
}

function normalizeBarCodeSetting() {
  if (formData.value.uniqueBarCode && formData.value.genSimpleLabelBarcode) {
    formData.value.genSimpleLabelBarcode = false
  }
}

// 获取输入框显示的值
function getPlankNameValue(index: number): string {
  return tempPlankNames[index]?.value ?? formData.value.plankNames[index] ?? ''
}

// 添加板件名
function handleAddPlankName() {
  const newIndex = formData.value.plankNames.length
  formData.value.plankNames.push('')
  // 初始化临时值
  tempPlankNames[newIndex] = {
    value: '',
    original: '',
  }
}

// 获得焦点时保存原始值
function handleFocusPlankName(index: number) {
  const originalValue = formData.value.plankNames[index] || ''
  // 如果还没有临时值，初始化它
  if (!tempPlankNames[index]) {
    tempPlankNames[index] = {
      value: originalValue,
      original: originalValue,
    }
  } else {
    // 如果已有临时值，更新原始值（防止多次获得焦点）
    tempPlankNames[index].original = originalValue
  }
  currentInputIndex.value = index
}

// 输入时更新临时值
function handleInputPlankName(e: any, index: number) {
  const value = e?.target.value
  if (!tempPlankNames[index]) {
    tempPlankNames[index] = {
      value: value,
      original: formData.value.plankNames[index] || '',
    }
  } else {
    tempPlankNames[index].value = value
  }
  currentInputPlankName.value = value
  currentInputIndex.value = index
}

// 失焦时如果没有保存，恢复原值
function handleBlurPlankName(index: number) {
  // 延迟执行，确保点击保存按钮时不会触发
  setTimeout(() => {
    // 如果当前索引不是这个输入框，说明可能点击了保存或其他操作，不恢复
    if (currentInputIndex.value !== index) {
      return
    }
    // 如果没有保存，恢复原值
    if (tempPlankNames[index]) {
      tempPlankNames[index].value = tempPlankNames[index].original
      currentInputIndex.value = null
    }
  }, 200)
}

function handleDelPlank(index: number) {
  if (formData.value.isSurNotLayout) {
    formData.value.plankNames.splice(index, 1)
    // 清理临时值
    delete tempPlankNames[index]
    // 重新整理索引
    const newTempPlankNames: Record<
      number,
      { value: string; original: string }
    > = {}
    Object.keys(tempPlankNames).forEach((key) => {
      const numKey = Number(key)
      if (numKey < index) {
        newTempPlankNames[numKey] = tempPlankNames[numKey]
      } else if (numKey > index) {
        newTempPlankNames[numKey - 1] = tempPlankNames[numKey]
      }
    })
    Object.keys(newTempPlankNames).forEach((key) => {
      tempPlankNames[Number(key)] = newTempPlankNames[Number(key)]
    })
    Object.keys(tempPlankNames).forEach((key) => {
      if (!newTempPlankNames[Number(key)]) {
        delete tempPlankNames[Number(key)]
      }
    })
  }
}

// 保存板件名
function handleSavePlankName(name: string, index: number) {
  if (formData.value.isSurNotLayout) {
    // 立即清除索引，防止失焦事件恢复值
    currentInputIndex.value = null
    const valueToSave =
      tempPlankNames[index]?.value ?? currentInputPlankName.value

    // 如果输入值不为空，检查是否有重复
    if (valueToSave && valueToSave.trim()) {
      const trimmedValue = valueToSave.trim()

      // 检查是否有重复（排除当前索引）
      const duplicateIndex = formData.value.plankNames.findIndex(
        (item: string, idx: number) =>
          idx !== index && item && item.trim() === trimmedValue
      )

      if (duplicateIndex !== -1) {
        // 有重复，显示错误提示并恢复原始值
        Vue.prototype.$message.error('板件名不能重复')
        // 恢复原始值
        const originalValue =
          tempPlankNames[index]?.original ??
          formData.value.plankNames[index] ??
          ''
        if (tempPlankNames[index]) {
          tempPlankNames[index].value = originalValue
        }
        // 恢复表单中的值
        Vue.prototype.$set(formData.value.plankNames, index, originalValue)
        return
      }
    }

    Vue.set(formData.value.plankNames, index, valueToSave)
    // 更新临时值的原始值，以便下次编辑时使用
    if (tempPlankNames[index]) {
      tempPlankNames[index].original = valueToSave
    }
  }
}

/**
 * @desc 限制只能输入正数
 * @param val
 */
function inpCheck(val: number) {
  verifyInputNumber(val, formData.value, ['surpLabelSetValue'], '3-3', false)
}
function handleSaveSettings() {
  if (!validateSaveData(formData.value)) return

  if (formData.value.enableSubTagDataSource) {
    if (!formData.value.subTagDataSource.length) {
      showTipAndScroll(
        subTagDataSourceTip,
        translateLang('请至少添加一个数据源'),
        'subTagDataSourceTip'
      )
      return
    } else if (formData.value.subTagDataSource.some((item: string) => !item)) {
      showTipAndScroll(
        subTagDataSourceTip,
        translateLang('数据源不能为空，请选择'),
        'subTagDataSourceTip'
      )
      return
    } else {
      subTagDataSourceTip.value = ''
    }
  }

  // 如果定义余料大板不排指定板件开关打开却没有输入板件名 则不允许保存
  if (formData.value.isSurNotLayout) {
    const condition1 = !formData.value.plankNames.filter((item: string) =>
      item.trim()
    ).length
    const condition2 = formData.value.plankNames.some(
      (item: string) => !item.trim()
    )
    if (condition1) {
      showTipAndScroll(addPlankTip, '请至少添加一个小板名称', 'addPlankTip')
      return
    } else if (condition2) {
      showTipAndScroll(addPlankTip, '板件名不能为空，请输入', 'addPlankTip')
      return
    } else {
      addPlankTip.value = ''
    }
  }

  isSaveSettings.value = true
  formData.value.isCheckBigPlankSynchronous = !dataHasDifOpenTip.value
  updateLocalPreference(formData.value, ({ isErr }) => {
    if (!isErr) {
      Message.success(translate('common.saveSuccess'))
      genFinalRecordFn(formData.value, oriData)
      handleBury(formData.value, oriData)
    }
    isSaveSettings.value = false
  })
}

/** tip 首次由隐藏变为显示时，需等 DOM 更新后再滚动，否则 scrollIntoView 无效 */
function showTipAndScroll(
  tipRef: { value: string },
  tipText: string,
  tipId: string
) {
  tipRef.value = tipText
  nextTick(() => {
    document.getElementById(tipId)?.scrollIntoView({ behavior: 'smooth' })
  })
}

// 保存时的数据验证
function validateSaveData(formData: formDataType) {
  const {
    isSurpLabelSetValue,
    surpLabelSetValue,
    enableMixPaiban,
    mixPaibanSettings,
  } = formData
  // 如果余料标签设置开关打开却没有输入值 则不允许保存
  if (isSurpLabelSetValue && !surpLabelSetValue) {
    surpTagThrouInp.value.$el.classList.add('surpInpcheck')
    return false
  }

  // 开启了不同小板混排
  if (enableMixPaiban) {
    const isAllValid = mixPaibanSettings.every(
      (setting) =>
        setting.matCode &&
        setting.originTexture.length > 0 &&
        setting.targetTexture
    )
    if (!isAllValid) {
      message.error(translateLang('混排方案缺失必填项，请检查'))
      return false
    }
    // 校验相同材质是否存在定义的颜色重复的情况
    const colorGroupByMatCode = groupBy(mixPaibanSettings, 'matCode')
    return !Object.entries(colorGroupByMatCode).some(([key, settings]) => {
      const targetTextures = settings.map((setting) => setting.targetTexture)
      // 去重
      const uniqueTargetTextures = [...new Set(targetTextures)]
      if (uniqueTargetTextures.length !== targetTextures.length) {
        message.error(`相同材质【${key}】存在定义的颜色重复的情况`)
        return true
      }
    })
  }

  return true
}

// 埋点处理
function handleBury(currentData: any, oldData: any) {
  const buryKeyArr = [
    'isFrameDoorTip',
    'exNextTip',
    'isDesMaterialNoCutTip',
    'isCheckBigPlankSynchronous',
    'engravSwitchCloseAlwaysShow',
    'isSurpLabelSetValue',
    'inner_shape_tool_match',
    'enableSubTagDataSource',
    'isSurNotLayout',
    'uniqueBarCode',
    'genSimpleLabelBarcode',
    'isUsePlankReuseMatchingPlankName',
  ]
  Object.keys(currentData).forEach((key) => {
    if (
      buryKeyArr.includes(key) &&
      currentData[key] &&
      currentData[key] != oldData[key]
    ) {
      buryPointApi('more_setting', key)
    }
  })
}

/** 获取数据库中存储的文件句柄 */
async function getLocalFolder() {
  try {
    localFolder.folders = Object.freeze(await getFileDBData('folders'))
    const currentFolder = (await getFileDBData('currentUserFolder')) as Data
    const current = localFolder.folders.find(
      (it: any) => it.handle?.name === currentFolder?.handle?.name
    )
    localFolder.current = current?.id
    localFolder.oriCurrent = localFolder.current
  } catch (error) {
    console.error(error)
  }
}
/** 添加新的本地文件夹 */
async function handleAddNewFolder() {
  const { permission } = (await storageLocalFolder()) ?? {}
  if (!permission) {
    message.warning(translate('fileManagerPage.notOpeFolderPermission'))
  }
  getLocalFolder()
  buryPoint({
    function_module: 'more_setting',
    function_point: 'add_new_export_folder_localtion',
  })
}
/** 更新当前使用的本地文件存储 */
async function handleLocalFolderChange(val: any) {
  const target = localFolder.folders.find((it: any) => it.id === val)
  if (!target) return
  const isExist = await folderIsExist(target.handle)

  if (!isExist) {
    message.error(translate('fileManagerPage.notFindFolder'))
    localFolder.current = localFolder.oriCurrent
    return
  }
  await addFileDBData(
    'currentUserFolder',
    {
      handle: target.handle,
      id: GenerateFileDB.currentUserFolderPrimaryKey,
    },
    'put'
  )
  // 生成文件下载位置已更换为
  message.success(
    translate('fileManagerPage.downloadPositionChangeByType', {
      type: `【${target.handle?.name}】`,
    })
  )
  localFolder.oriCurrent = localFolder.current
  buryPoint({
    function_module: 'more_setting',
    function_point: 'export_folder_localtion',
  })
}
/** 删除保存使用的文件句柄 */
function handleDeleteLocalFolder(item: any) {
  proxy
    .$confirm(
      translate('fileManagerPage.isDeleteFolder'),
      translate('common.warmTip'),
      {
        confirmButtonText: translate('common.confirm'),
        cancelButtonText: translate('common.cancel'),
        type: 'warning',
      }
    )
    .then(async () => {
      const currentFolder = (await getFileDBData('currentUserFolder')) as Data
      await deleteFileDBData('folders', item.id)
      if (currentFolder?.handle?.name === item?.handle?.name) {
        await deleteFileDBData('currentUserFolder', currentFolder.id!)
        localFolder.current = null
      }
      getLocalFolder()
      message.success(translate('common.deleteSuccess'))
    })
}

// 比较通用设置的数据
function compareGeneralSettings(current: any, ori: any) {
  let compareMsg = [
    {
      title: '通用设置',
      keys: [
        'isFrameDoorTip',
        'isCheckBigPlankSynchronous',
        'engravSwitchCloseAlwaysShow',
        'exNextTip',
        'isDesMaterialNoCutTip',
        'isSurpLabelSetValue',
        // 判断余料标签是否展示的大小阈值
        'surpLabelSetValue',
        'inner_shape_tool_match',
      ],
    },
    {
      title: '下载设置',
      keys: ['is_use_folder_export'],
    },
    {
      title: '小板副标签设置',
      keys: ['enableSubTagDataSource', 'subTagDataSource'],
    },
    {
      title: '余料设置',
      keys: ['isSurNotLayout', 'plankNames'],
    },
    {
      title: '导出样表设置',
      keys: ['uniqueBarCode', 'genSimpleLabelBarcode'],
    },
    {
      title: '排版设置',
      keys: ['isUsePlankReuseMatchingPlankName'],
    },
  ]
  // 平铺数据
  current = flatObj(current)
  ori = flatObj(ori)
  return {
    key: '',
    dataArr: [
      {
        type: 'form',
        current: {
          ...current,
          subTagDataSource: current.subTagDataSource.map(
            (item: any) =>
              subTagOptions.value.find((option: any) => option.value === item)
                ?.label
          ),
        },
        ori: {
          ...ori,
          subTagDataSource: ori.subTagDataSource.map(
            (item: any) =>
              subTagOptions.value.find((option: any) => option.value === item)
                ?.label
          ),
        },
        compareMsg,
        formTextObj: {
          isFrameDoorTip: '骨骼门加工时生成提示弹窗',
          isCheckBigPlankSynchronous:
            '云排版原片数据与guigui不同步时生成提示弹窗',
          engravSwitchCloseAlwaysShow:
            '雕刻机中开关控制的二级内容关闭开关后依旧展示',
          is_use_folder_export: '生产文件以解压后的形式下载',
          exNextTip: '使用异形余料/异形嵌套排版时生成提示弹窗',
          isDesMaterialNoCutTip:
            '指定小板材质不下料的板件,有分配到雕刻机的孔槽时生成提示弹窗',
          isSurpLabelSetValue: '判断余料标签是否展示的大小阈值',
          inner_shape_tool_match: '雕刻机加工内部异形自动选择合适刀具',
          enableSubTagDataSource: '设置副标签生成的生效数据源',
          subTagDataSource: '添加的数据源',
          isSurNotLayout: '定义余料大板不排指定板件',
          plankNames: '余料大板不排指定板件名',
          uniqueBarCode: '板件条码唯一',
          genSimpleLabelBarcode: '生成简易格式板件条码',
          isUsePlankReuseMatchingPlankName: '布局复用匹配板件名称',
        },
      },
    ],
  }
}
// 生成操作记录
function genFinalRecordFn(current: any, ori: any) {
  const recordData = {
    key: '', //操作记录最外层的名字
    operateArr: [compareGeneralSettings(current, ori)],
  }
  genFinalRecord(recordData, '更多设置', '', () => {
    updatePreference({ data: preference.value as any })
  })
}

function updatePreference({ data, isErr }: PreferenceUpdateFnParam) {
  if (isErr) {
    return Message.error(translate('common.noModificationPermission'))
  }
  formData.value = deepCopy(data)
  // 如果加载的数据里面没有获取到参数engravSwitchCloseAlwaysShow、isSurpLabelSetValue，，给一个默认值为true
  const generateSettingTrue = [
    'engravSwitchCloseAlwaysShow',
    'isDesMaterialNoCutTip',
    'isFrameDoorTip',
  ]
  const generateSettingFalse = [
    'isCheckBigPlankSynchronous',
    'isSurpLabelSetValue',
    'inner_shape_tool_match',
    'isSurNotLayout',
    'uniqueBarCode',
    'genSimpleLabelBarcode',
    'isUsePlankReuseMatchingPlankName',
    'enableSubTagDataSource',
  ]
  // 遍历生成设置
  generateSettingTrue.forEach((key: any) => {
    if (data[key] === undefined) {
      // 增加一个参数
      Vue.set(formData.value, key, true)
    }
  })
  generateSettingFalse.forEach((key: any) => {
    if (data[key] === undefined) {
      // 增加一个参数
      Vue.set(formData.value, key, false)
    }
  })
  if (!data.hasOwnProperty('plankNames')) {
    Vue.set(formData.value, 'plankNames', [])
  }
  if (!data.hasOwnProperty('subTagDataSource')) {
    Vue.set(formData.value, 'subTagDataSource', [])
  }
  // 清理临时值，因为数据已重新加载
  Object.keys(tempPlankNames).forEach((key) => {
    delete tempPlankNames[Number(key)]
  })
  currentInputIndex.value = null
  dataHasDifOpenTip.value = !formData.value.isCheckBigPlankSynchronous
  normalizeBarCodeSetting()
  // 原始数据 操作记录做对比
  oriData = deepCopy(data)
}

return { __sfc: true,proxy, isSaveSettings, dataHasDifOpenTip, surpTagThrouInp, formData, oriData, currentInputPlankName, currentInputIndex, addPlankTip, tempPlankNames, localFolder, isSupportFileSys, isNetWorkSafe, isSupportOpe, webToQt, preference, isLoadPref, hasSubTagPermission, subTagOptions, subTagDataSourceTip, getSubTagOptions, handleAddSubTagDataSource, handleDelSubTagDataSource, handleChangeSubTagDataSource, handleUniqueBarCodeChange, handleGenSimpleLabelBarcodeChange, normalizeBarCodeSetting, getPlankNameValue, handleAddPlankName, handleFocusPlankName, handleInputPlankName, handleBlurPlankName, handleDelPlank, handleSavePlankName, inpCheck, handleSaveSettings, showTipAndScroll, validateSaveData, handleBury, getLocalFolder, handleAddNewFolder, handleLocalFolderChange, handleDeleteLocalFolder, compareGeneralSettings, genFinalRecordFn, updatePreference, buryPoint, MPaibanPlan }
}

})